import styled from "styled-components";

const DeliveryItemOverviewStyled = styled.div`
    display: flex;
    gap: 24px;
    padding: 12px 16px;
    background: white;
    border-radius: 8px;
    width: 100%;


    .logoWrapper {
        width: 40px;
        height: 44px;
        padding-top: 4px;
        border-radius: 5px;

        & > img {
            width: 40px;
            height: 40px;
            object-fit: contain;
        }
     }

     .infoPanel {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
     
      }

      .contentWrapper {
        display: flex;
        flex-direction: column;
        width: 100%;

         & > p {
            margin: 0;
         }
       }

       .title {
        color: #3D4543;
        font-size: 1.6rem;
        font-weight: 700;
       }

        .content {
        color: #757575;
        font-size: 1.4rem;
        font-weight: 400;
        }

        .semiTitle {
        font-size: 1.4rem;
        }


 
`

export { DeliveryItemOverviewStyled };
